import classnames from 'classnames';

import CSSModule from './Contact.module.scss';
import ContactFaqBlock from './ContactFaqBlock';
import ContactSupportBlock from './ContactSupportBlock';

interface Props {
  className?: string;
}

const Contact: React.FC<Props> = ({ className }) => (
  <div className={classnames(CSSModule.Contact, className)}>
    <ContactFaqBlock />
    <p className={CSSModule.Contact__Paragraph}>
      解決しない場合は下記のフォームよりお問い合わせください。
    </p>
    <ContactSupportBlock />
  </div>
);

export default Contact;
